import { gql } from '@apollo/client';

export const fetchInvoicesByEntitlementIdPPC = gql`
  query fetchInvoicesByEntitlementIdPPC($searchOptions: InvoiceWhereFilter) {
    invoices(searchOptions: $searchOptions) {
      results {
        id
        paymentCurrency
        pricingCurrency
        lineItems {
          entitlementId
          amount
        }
      }
    }
  }
`;
